import React from 'react';
import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
}) => (
  <div className="flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-edge bg-paper-muted p-8 text-center">
    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-paper-inset">
      {icon}
    </div>
    <h3 className="mt-4 text-sm font-medium text-ink">{title}</h3>
    <p className="mt-1 text-sm text-ink-muted">{description}</p>
    {actionLabel && onAction && (
      <div className="mt-4">
        <Button
          type="button"
          onClick={onAction}
          variant="outline"
          className="inline-flex items-center"
        >
          {actionLabel}
        </Button>
      </div>
    )}
  </div>
);
